export default {
    NetIP: '99.79.27.254'
}